import { SAVE_USER, REMOVE_USER } from './actionTypes';

import User from '../../models/User';

function removeUser() {
  return {
    type: REMOVE_USER
  }
}

function userSuccess(user: User) {
  return {
    type: SAVE_USER,
    data: user
  }
}

function saveUserAction(user: User) {

  return (dispatch: any) => {

    dispatch(userSuccess(user));
  };
}

export {
  userSuccess,
  saveUserAction,
  removeUser
};